import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { SearchInputComponent } from '../../../components/search-input/search-input.component';
import { SvgIconComponent } from '../../../components/svg-icons/svg-icon.component';
import { ButtonComponent } from '../../../components/button/button.component';
import { NavigateLinkDirective } from '../../directives/navigate-link/navigate-link.directive';
import { NavigationState } from '../../services/navigation-state.service';
import { FlatButtonDirective } from '../../directives/flat-button/flat-button.directive';
import { ProductRequestSearchProvider } from '../../../components/search-input/providers/product-request-search.provider';
import { Router } from '@angular/router';
import { ManagedProductSearchProvider } from '../../../components/search-input/providers/managed-product-search.provider';
import { ProductRequestSearchUseCase } from '../../../pages/bulletin-board/product-request-search.usecase';
import { ManagedProductSearchUseCase } from '../../../pages/managed-product/managed-product-search.usecase';
import { SessionRepository } from '../../services/repositories/session.repository';

interface NavigationMenuItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-navigation',
  imports: [
    CommonModule,
    MatRippleModule,
    SearchInputComponent,
    SvgIconComponent,
    ButtonComponent,
    NavigateLinkDirective,
    FlatButtonDirective,
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
  readonly #router = inject(Router);
  readonly #sessionRepository = inject(SessionRepository);
  readonly #navigationState = inject(NavigationState);
  readonly productRequestSearchProvider = inject(ProductRequestSearchProvider);
  readonly managedProductSearchProvider = inject(ManagedProductSearchProvider);
  readonly #productRequestSearchUseCase = inject(ProductRequestSearchUseCase);
  readonly #managedProductSearchUseCase = inject(ManagedProductSearchUseCase);
  protected readonly isMobileNavigationOpened = this.#navigationState.isMobileNavVisible;
  protected readonly currentUser = this.#sessionRepository.user;

  protected readonly navigationMenuItems: NavigationMenuItem[] = [
    {
      label: '作品管理',
      icon: '/assets/icons/list.svg',
      route: '/managed-product',
    },
    {
      label: 'マイページ',
      icon: '/assets/icons/circle-user-solid.svg',
      route: '/dashboard',
    },
    {
      label: 'お知らせ',
      icon: '/assets/icons/bell-solid.svg',
      route: '/notification',
    },
  ];

  protected readonly mobileMenuItems: NavigationMenuItem[] = [
    {
      label: '注文情報',
      icon: '/assets/icons/board.svg',
      route: '/',
    },
    ...this.navigationMenuItems,
  ];

  protected readonly guideLinks = {
    loggedIn: {
      url: 'https://about.dealers-stock.jp/guide',
      label: '使い方ガイド',
      icon: '/assets/icons/beginner.svg',
    },
    loggedOut: {
      url: 'https://about.dealers-stock.jp',
      label: '使い方ガイド',
      icon: '/assets/icons/beginner.svg',
    },
  };

  get keywordControl() {
    // URLが/managed-productだった場合はmanagedProductSearchUseCaseのformControlを返す
    if (this.#router.url.startsWith('/managed-product')) {
      return this.#managedProductSearchUseCase.formModel.formGroup.controls.keyword;
    }
    return this.#productRequestSearchUseCase.formModel.formGroup.controls.keyword;
  }

  get searchProvider() {
    // URLが/managed-productだった場合はmanagedProductSearchProviderを返す
    if (this.#router.url.startsWith('/managed-product')) {
      return this.managedProductSearchProvider;
    }
    return this.productRequestSearchProvider;
  }

  openMobileNav() {
    this.#navigationState.setMobileNavigationListVisibility(true);
  }

  closeMobileNav() {
    this.#navigationState.setMobileNavigationListVisibility(false);
  }

  navigateToLoginPage() {
    this.closeMobileNav();
    const path = this.#router.url;
    this.#router.navigateByUrl(`/login?returnUrl=${encodeURIComponent(path)}`);
  }
}
